// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';

console.log('[PRODUCTION DEBUG] Supabase client initialization starting...', {
  timestamp: new Date().toISOString(),
  hasUrl: !!import.meta.env.VITE_SUPABASE_URL,
  hasKey: !!import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
});

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

console.log('[PRODUCTION DEBUG] Supabase client created successfully', {
  timestamp: new Date().toISOString()
});